import { render, staticRenderFns } from "./SelectComponente.vue?vue&type=template&id=32d76a45"
import script from "./SelectComponente.vue?vue&type=script&lang=ts"
export * from "./SelectComponente.vue?vue&type=script&lang=ts"
import style0 from "./SelectComponente.vue?vue&type=style&index=0&id=32d76a45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports